import { NEGYEDEV_JEL, negyedevesE, NEM_IRTA_JEL, nemIrtaE, strukturaltRovid, stornoE } from '../ertekeles-modositas';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import moment from 'moment';
import { DataService } from '../data.service';

@Component({
  selector: 'app-szuloi-jegyek',
  templateUrl: './szuloi-jegyek.component.html',
  styleUrls: ['./szuloi-jegyek.component.scss'],
})
export class SzuloiJegyekComponent implements OnInit {
  user$: any;
  sajatIntezmeny: any;
  gyerekek: any[] = [];
  kivtanulo: string | null = null;
  /*  Ha a TANULÓ lépett be, ez a saját sora. Ilyenkor nincs mit választani: a
   *  nevét kiírjuk, a legördülő helyett. */
  sajatSor: any = null;
  aktivTanev = this.getDefaultTanev();
  aktivFelev: string | null = null;
  zaroBeallitas: any = null;
  adat: any = null;
  readonly elsoFelevHonapok = ['09', '10', '11', '12', '01/I'];
  readonly masodikFelevHonapok = ['01/II', '02', '03', '04', '05', '06'];

  constructor(
    private http: HttpClient,
    private oauth: OAuthService,
    private data: DataService
  ) {}

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims());
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    await this.resolveAktivTanev();
    this.loadZaroBeallitas();
    await this.loadGyerekek();
  }

  /**
   *  A megjelenített tanév. A szülőnek nincs fejléc-választója, ezért ITT kap egyet:
   *  a korábbi évek jegyei különben elérhetetlenek maradnának, pedig a bizonyítvány
   *  és a félévi értesítő is azokra hivatkozik.
   */
  tanevLista: any[] = [];

  async resolveAktivTanev() {
    const tanev = await this.data.getFromStorage('tanev');
    const tanevadatok = await this.data.getFromStorage('tanevadatok');

    try {
      const aktiv = tanev ? JSON.parse(tanev) : null;
      const lista = tanevadatok ? JSON.parse(tanevadatok) : [];
      // Csak a MÁR ELKEZDŐDÖTT tanévek: az előkészítés alattiban még nincs jegy.
      this.tanevLista = (lista || [])
        .filter((t: any) => t?.tankezd && moment(t.tankezd).isSameOrBefore(moment(), 'day'))
        .sort((a: any, b: any) => Number(b.id) - Number(a.id))
        // A választó értéke SZÖVEG, mert az aktivTanev is az (moment().format('YYYY'));
        // szám-szöveg keveredésnél a legördülő nem jelölné ki az aktuális évet.
        .map((t: any) => ({ ...t, ev: String(t.id), cimke: `${Number(t.id)}/${Number(t.id) + 1}` }));
      const aktualis = (lista || []).find((item: any) => item.id == aktiv?.aktualistanev)
        || this.tanevLista[0];
      if (aktualis?.tankezd) {
        this.aktivTanev = moment(aktualis.tankezd).format('YYYY');
      }
      this.aktivFelev = aktualis?.felev ? moment(aktualis.felev).format('YYYY-MM-DD') : null;
    } catch (error) {
      console.error('Aktív tanév feloldási hiba:', error);
    }
  }

  /** Tanévváltás a szülői oldalon: a félév-határ is vele mozog (januári bontás). */
  async tanevValt(ev: any) {
    const valasztott = this.tanevLista.find((t: any) => String(t.ev) === String(ev));
    if (!valasztott) return;
    this.aktivTanev = moment(valasztott.tankezd).format('YYYY');
    this.aktivFelev = valasztott.felev ? moment(valasztott.felev).format('YYYY-MM-DD') : null;
    if (this.kivtanulo) await this.loadJegyek();
  }

  tanevCimke(t: any): string {
    const ev = Number(t?.id);
    return Number.isFinite(ev) ? `${ev}/${ev + 1}` : String(t?.id ?? '');
  }

  getDefaultTanev(): string {
    const now = moment();
    const ev = now.year();
    return String(now.month() >= 8 ? ev : ev - 1);
  }

  async loadGyerekek() {
    if (!this.user$?.username || !this.sajatIntezmeny?.intezmenyId) return;

    await this.data.showLoading('Gyermekek betöltése...');
    this.http
      .get<any[]>(
        `/api/nyilvantartas/szulogyereke/${this.user$.username}/${this.sajatIntezmeny.intezmenyId}`
      )
      .subscribe({
        next: async (response: any[] = []) => {
          this.gyerekek = Array.isArray(response) ? response : [];
          /*  Tanulói belépés: a lista egyetlen sora ő maga. Rögzítjük – enélkül a
           *  képernyő üres marad, amíg a tanuló ki nem választja saját magát. */
          this.sajatSor = this.data.sajatTanulo(this.gyerekek);
          if (this.sajatSor) this.kivtanulo = this.sajatSor.oktazon;
          else if (!this.kivtanulo && this.gyerekek.length === 1) {
            this.kivtanulo = this.gyerekek[0].oktazon;
          }

          await this.data.hideLoading();

          if (this.kivtanulo) {
            this.loadJegyek();
          }
        },
        error: async (error) => {
          console.error('Gyermeklista lekérési hiba:', error);
          await this.data.hideLoading();
          this.data.sendToast('Nem sikerült betölteni a gyermeklistát.', 'error');
        },
      });
  }

  onTanuloValtozas(event: any) {
    this.kivtanulo = event?.oktazon ?? event ?? null;
    this.loadJegyek();
  }

  /*  BEJELENTETT SZÁMONKÉRÉSEK.
   *
   *  A tanár a naplóban osztálynak VAGY csoportnak jelenti be a dolgozatot. A kiszolgáló
   *  a tanulóból indul: az osztályának szólókat és azoknak a csoportoknak a
   *  bejelentéseit adja, amelyekbe jár – így egy több osztályt átfogó nyelvi csoport
   *  tesztjét mindegyik érintett osztály diákja és szülője látja. */
  szamonkeresek: any[] = [];

  get kozelgoSzamonkeresek(): any[] {
    const ma = moment().format('YYYY-MM-DD');
    return (this.szamonkeresek || []).filter((s: any) => String(s?.datum || '') >= ma);
  }

  loadSzamonkeresek() {
    this.szamonkeresek = [];
    if (!this.kivtanulo || !this.user$?.username || !this.sajatIntezmeny?.intezmenyId) return;
    this.http
      .get<any[]>(
        `/api/szamonkeres-terv/tanulo/${encodeURIComponent(this.user$.username)}/${this.kivtanulo}/${this.sajatIntezmeny.intezmenyId}?ev=${this.aktivTanev}`
      )
      .subscribe({
        next: (r: any[]) => { this.szamonkeresek = Array.isArray(r) ? r : []; },
        //  Kiegészítő információ: ha nem jön meg, a jegyek ettől még használhatók.
        error: (e) => { console.error('Számonkérések lekérési hiba:', e); this.szamonkeresek = []; },
      });
  }

  async loadJegyek() {
    if (!this.kivtanulo || !this.user$?.username || !this.sajatIntezmeny?.intezmenyId) {
      this.adat = null;
      this.szamonkeresek = [];
      return;
    }
    this.loadSzamonkeresek();

    await this.data.showLoading('Jegyek betöltése...');
    this.http
      .get<any>(
        `/api/nyilvantartas/gondviselo-jegyek/${this.sajatIntezmeny.intezmenyId}/${this.user$.username}/${this.kivtanulo}?ev=${this.aktivTanev}`
      )
      .subscribe({
        next: async (response: any) => {
          this.adat = response || null;
          await this.data.hideLoading();
        },
        error: async (error) => {
          console.error('Szülői jegyek lekérési hiba:', error);
          this.adat = null;
          await this.data.hideLoading();
          this.data.sendToast('Nem sikerült betölteni a jegyeket.', 'error');
        },
      });
  }

  loadZaroBeallitas() {
    if (!this.sajatIntezmeny?.intezmenyId) return;

    this.http
      .get<any>(`/api/ertekeles-zaro/beallitas/${String(this.sajatIntezmeny.intezmenyId).replace(/^\/+|\/+$/g, '')}`)
      .subscribe({
        next: (response) => {
          this.zaroBeallitas = response || null;
        },
        error: (error) => {
          console.error('Záróértékelés láthatóság betöltési hiba:', error);
          this.zaroBeallitas = null;
        },
      });
  }

  formatDatum(datum: any): string {
    if (!datum) return '';
    const formatted = moment(datum);
    return formatted.isValid() ? formatted.format('YYYY.MM.DD.') : String(datum);
  }

  getMonthKeyFromDatum(datum: any): string | null {
    if (!datum) return null;

    const d = moment(datum);
    if (!d.isValid()) return null;

    const honap = d.month() + 1;
    if (honap === 1) {
      const cutoff = moment(this.aktivFelev, 'YYYY-MM-DD', true);
      if (cutoff.isValid() && cutoff.month() === 0) {
        return d.isSameOrBefore(cutoff, 'day') ? '01/I' : '01/II';
      }

      return d.date() <= 19 ? '01/I' : '01/II';
    }

    return String(honap).padStart(2, '0');
  }

  getTantargyMonthMap(tantargy: any): Record<string, any[]> {
    const months: Record<string, any[]> = {};

    for (const item of tantargy?.ertekelesek || []) {
      if (this.isZaroErtekelesItem(item)) continue;

      const key = this.getMonthKeyFromDatum(item?.datum);
      if (!key) continue;
      if (!months[key]) months[key] = [];
      months[key].push(item);
    }

    Object.keys(months).forEach((key) => {
      months[key] = (months[key] || []).slice().sort((a: any, b: any) =>
        String(a?.datum || '').localeCompare(String(b?.datum || ''))
      );
    });

    return months;
  }

  getTantargyFelevi(tantargy: any): any[] {
    if (!this.isZaroLathato('felevi')) return [];
    return (tantargy?.ertekelesek || []).filter((item: any) => String(item?.modja ?? '') === '2');
  }

  getTantargyEvvegi(tantargy: any): any[] {
    if (!this.isZaroLathato('evvegi')) return [];
    return (tantargy?.ertekelesek || []).filter((item: any) => String(item?.modja ?? '') === '3');
  }

  getTantargyMasodikFelevi(tantargy: any): any[] {
    return this.getTantargyEvvegi(tantargy);
  }

  isZaroLathato(tipus: 'felevi' | 'evvegi'): boolean {
    const key = tipus === 'felevi' ? 'felevi_lathato_tol' : 'evvegi_lathato_tol';
    const datum = this.zaroBeallitas?.[key];
    if (!datum) return true;

    const tol = moment(datum);
    return tol.isValid() ? moment().isSameOrAfter(tol, 'day') : true;
  }

  isZaroErtekelesItem(item: any): boolean {
    const modja = String(item?.modja ?? '').trim();
    if (modja === '2' || modja === '3') return true;
    //  Évközi és negyedéves jegy nem záró – a negyedéves a hónapjában jelenik meg.
    if (modja === '1' || negyedevesE(item)) return false;

    const tipusNev = String(item?.ertnev ?? item?.tipus_nev ?? item?.szamonkeres_tipusa ?? item?.tema ?? '').toLowerCase();
    return tipusNev.includes('félév')
      || tipusNev.includes('felev')
      || tipusNev.includes('év végi')
      || tipusNev.includes('ev vegi')
      || tipusNev.includes('évvegi')
      || tipusNev.includes('evvegi');
  }

  isEvvegiZaroErtekelesItem(item: any): boolean {
    const modja = String(item?.modja ?? '').trim();
    if (modja === '3') return true;

    const tipusNev = String(item?.ertnev ?? item?.tipus_nev ?? item?.szamonkeres_tipusa ?? item?.tema ?? '').toLowerCase();
    return tipusNev.includes('év végi')
      || tipusNev.includes('ev vegi')
      || tipusNev.includes('évvegi')
      || tipusNev.includes('evvegi');
  }

  getFelevCutoff(): moment.Moment {
    const tanev = Number(this.aktivTanev);
    const cutoffEv = Number.isFinite(tanev) ? tanev + 1 : moment().year();
    return moment(`${cutoffEv}-01-19`, 'YYYY-MM-DD');
  }

  negyedevesE = negyedevesE;
  /** „Nem írta meg” (–): a dolgozatot nem írta meg; nem jegy, az átlagba nem számít. */
  nemIrtaE = nemIrtaE;
  /*  STORNÓZOTT jegy: a szülő is ÁTHÚZVA látja – a jegy nem tűnik el nyomtalanul (ez az
   *  átláthatóság), de az átlagba nem számít. Az okát a kiszolgáló nem adja ki. */
  stornoE = stornoE;

  negyedevJel(item: any): string {
    return NEGYEDEV_JEL[String(item?.modja)] || '';
  }

  /** Záró/negyedéves érdemjegynél „5D”, „4”, „85%”; egyébként a szokásos rövid alak. */
  jegyRovid(item: any): string {
    if (nemIrtaE(item)) return NEM_IRTA_JEL;
    return strukturaltRovid(item) ?? this.formatErtekelesRovid(item?.jegy);
  }

  formatErtekelesRovid(ertekeles: any): string {
    const value = String(ertekeles ?? '').trim();
    const fokozatMap: Record<string, string> = {
      'Példás': 'P',
      'Jó': 'J',
      'Változó': 'V',
      'Rossz': 'H',
      'Hanyag': 'H',
      'R': 'H',
    };

    // A '/' csak a magatartás/szorgalom formátumnál jelent kettéosztást (pl.
    // "Példás / Jó"), ahol minden rész rövid fokozat. Egy '/' jelet TARTALMAZÓ
    // szöveges értékelést NEM szabad így kezelni – az lentebb 'SZ' lesz.
    if (value.includes('/')) {
      const reszek = value.split('/').map((resz) => resz.trim());
      const csakFokozat = reszek.every((resz) => !!fokozatMap[resz] || resz.length <= 4);
      if (csakFokozat) {
        return reszek.map((resz) => fokozatMap[resz] || resz).join(' / ');
      }
    }

    if (fokozatMap[value]) return fokozatMap[value];
    //  Szám (pl. NKP-eredmény „48.5%”) sosem „SZ”: az a hosszú szöveges értékelés rövidítése.
    if (/^-?\d+([.,]\d+)?\s*%?$/.test(value)) return value.replace(/^(-?\d+)[.,]\d+/, '$1').replace(/\s+/g, '');
    if (value.length > 4) return 'SZ';
    return value;
  }

  getSpecialErtekelesReszletek(ertekeles: any): { magatartas: string; szorgalom: string } | null {
    const value = String(ertekeles ?? '').trim();
    if (!value.includes('/')) return null;

    const [magatartasRaw, szorgalomRaw] = value.split('/').map((resz) => resz.trim());
    return {
      magatartas: this.formatErtekelesRovid(magatartasRaw),
      szorgalom: this.formatErtekelesRovid(szorgalomRaw),
    };
  }

  isLongErtekeles(ertekeles: any): boolean {
    return String(ertekeles ?? '').trim().length > 4;
  }

  getNumericErtekeles(ertekeles: any): number | null {
    if (ertekeles === undefined || ertekeles === null) return null;

    if (typeof ertekeles === 'number') {
      return Number.isFinite(ertekeles) ? ertekeles : null;
    }

    const raw = String(ertekeles).trim();
    if (!raw) return null;

    const match = raw.match(/-?\d+(?:[.,]\d+)?/);
    if (!match) return null;

    const parsed = Number(match[0].replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  }

  getErtekelesSuly(item: any): number {
    const raw = item?.szorzo ?? item?.suly ?? item?.súly;
    if (raw === undefined || raw === null || raw === '') return 1;

    const value = typeof raw === 'number'
      ? raw
      : Number(String(raw).trim().replace(',', '.').replace('%', ''));

    /*  A 0 SÚLY IS SÚLY – és épp az a lényege.
     *
     *  A `<= 0` ág miatt a nullás szorzóból 1 lett: a „Diagnosztikus mérés (0x)"
     *  teljes súllyal számított bele az átlagba, pedig azért van 0-ra állítva, hogy
     *  NE számítson. Csak az értelmezhetetlen érték (hiányzó, szöveg, negatív) esik
     *  vissza 1-re; a kimondott 0 megmarad, és a hívó szűri ki (`weight > 0`).      */
    if (!Number.isFinite(value) || value < 0) return 1;
    return value > 10 ? value / 100 : value;
  }

  formatJegyek(ertekelesek: any[] = []): string {
    return (ertekelesek || [])
      .map((item: any) => String(item?.jegy ?? '').trim())
      .filter((item: string) => !!item)
      .join(', ');
  }

  getAtlag(ertekelesek: any[] = []): string {
    const szamok = (ertekelesek || [])
      //  A negyedéves értékelés nem számít az átlagba: összegzi a jegyeket, nem újabb jegy.
      //  A „nem írta meg” (–) sem: az még nem jegy. A stornózott sem: az áthúzva látszik, de nem jegy.
      .filter((item: any) => !this.isZaroErtekelesItem(item) && !negyedevesE(item) && !nemIrtaE(item) && !stornoE(item))
      .map((item: any) => ({
        value: this.getNumericErtekeles(item?.jegy),
        weight: this.getErtekelesSuly(item),
      }))
      .filter((item: { value: number | null; weight: number }): item is { value: number; weight: number } =>
        Number.isFinite(item.value as number) && Number.isFinite(item.weight) && item.weight > 0
      );

    if (!szamok.length) return '-';

    const weightedSum = szamok.reduce((sum, item) => sum + item.value * item.weight, 0);
    const weightSum = szamok.reduce((sum, item) => sum + item.weight, 0);
    const atlag = weightedSum / weightSum;
    //  A „%" csak a SZÁZALÉKOS értékelés átlagához tartozik. Eddig minden átlag megkapta,
    //  így az 1–5-ös jegyekből számolt 4,67 is „4,67%"-ként jelent meg a szülőnek.
    const szazalekos = (ertekelesek || []).some((item: any) =>
      item?.ertek_forma === 'szazalek' || /%\s*$/.test(String(item?.jegy ?? '')));
    return this.formatAtlagValue(atlag, szazalekos);
  }

  private formatAtlagValue(value: number, szazalekos = false): string {
    if (!Number.isFinite(value)) return '-';
    const decimals = this.getAtlagTizedesek();
    return `${value.toFixed(decimals).replace('.', ',')}${szazalekos ? '%' : ''}`;
  }

  private getAtlagTizedesek(): number {
    const raw = this.sajatIntezmeny?.ertekelesAtlagTizedes ?? this.sajatIntezmeny?.ertekeles_atlag_tizedes ?? 1;
    const value = Number(raw);
    if (!Number.isFinite(value)) return 1;
    return Math.min(3, Math.max(0, Math.trunc(value)));
  }

  getElsoFelevAtlag(ertekelesek: any[] = []): string {
    const cutoff = this.getFelevCutoff();
    const szurt = (ertekelesek || []).filter((item: any) => {
      const datum = moment(item?.datum);
      return datum.isValid() && (datum.isBefore(cutoff, 'day') || datum.isSame(cutoff, 'day'));
    });

    return this.getAtlag(szurt);
  }

  getMasodikFelevAtlag(ertekelesek: any[] = []): string {
    return this.getAtlag(ertekelesek || []);
  }

  getUtolsoJegy(ertekelesek: any[] = []): any | null {
    return (ertekelesek || [])[0] || null;
  }

  hasAnyErtekeles(tantargy: any): boolean {
    return (tantargy?.ertekelesek || []).length > 0;
  }
}
